import { render } from "./HomepageUzgent.vue?vue&type=template&id=7f9e37e4&scoped=true"
import script from "./HomepageUzgent.vue?vue&type=script&lang=js"
export * from "./HomepageUzgent.vue?vue&type=script&lang=js"

import "./HomepageUzgent.vue?vue&type=style&index=0&id=7f9e37e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9e37e4"]])

export default __exports__